var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-toolbar',{attrs:{"color":"secondary","dark":"","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('details')))])],1),_c('inventory-transaction-details',{ref:"inventoryTransactionDetails",attrs:{"inventory-transaction":_vm.inventoryTransaction}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }